// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_l7yM7 {
  width: 100%;
  /* Optional: show position indicator in red */
  z-index: 1;
}

.header_l7yM7::-webkit-scrollbar {
  width: 0px;  /* Remove scrollbar space */
  background: transparent;  /* Optional: just make scrollbar invisible */
  height: 0px;
}

.header_l7yM7::-webkit-scrollbar-thumb {
  background: transparent;
}

.scrollSmoother_k5MoC {
  z-index: 100;
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  will-change: transform;
}

.tableArea_Qikc0 {
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-elements/lib/esm/VirtualizedTableRenderer.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,6CAA6C;EAC7C,UAAU;AACZ;;AAEA;EACE,UAAU,GAAG,2BAA2B;EACxC,uBAAuB,GAAG,4CAA4C;EACtE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".header {\n  width: 100%;\n  /* Optional: show position indicator in red */\n  z-index: 1;\n}\n\n.header::-webkit-scrollbar {\n  width: 0px;  /* Remove scrollbar space */\n  background: transparent;  /* Optional: just make scrollbar invisible */\n  height: 0px;\n}\n\n.header::-webkit-scrollbar-thumb {\n  background: transparent;\n}\n\n.scrollSmoother {\n  z-index: 100;\n  pointer-events: none;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  will-change: transform;\n}\n\n.tableArea {\n  overflow: hidden;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `header_l7yM7`,
	"scrollSmoother": `scrollSmoother_k5MoC`,
	"tableArea": `tableArea_Qikc0`
};
export default ___CSS_LOADER_EXPORT___;
